module.exports = __webpack_public_path__ + "img/megafon.9e0f8504.png";